<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "BrandItem" });
import * as API from "../../services/api.js";
import { BRAND_STORE } from "../../services/store.js";
export let key;
export let onError = void 0;
const fetchBrand = (key2) => {
    if (key2 === void 0) {
        return;
    }
    void API.fetchBrand({ brandKey: key2 }, onError);
};
$: fetchBrand(key);
</script>

{#if key !== undefined && key in $BRAND_STORE }

    <slot brand = { $BRAND_STORE[key] }>

        <pre>{ JSON.stringify($BRAND_STORE[key], null, 4) }</pre>

    </slot>

{/if}